import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { modalSignup } from "./pricing-modal-signup-component.scss";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import CloseCircular from "/static/svg/close-circular.svg";
import { withGenericConfig } from "/contexts/generic-config-context";
class PricingModalSignupComponent extends PureComponent {
    render() {
        const { closeModalCallback, translate } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${modalSignup.__hash}` + " " + "modal-signup-container",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    onClick: closeModalCallback,
                    className: `jsx-${modalSignup.__hash}` + " " + "close-button",
                    children: /*#__PURE__*/ _jsx(CloseCircular, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${modalSignup.__hash}` + " " + "main-title",
                    children: [
                        " ",
                        translate("pricingPage.signupModalTitle"),
                        " "
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${modalSignup.__hash}` + " " + "secondary-title",
                    children: [
                        " ",
                        translate("pricingPage.signupModalSecondaryTitle"),
                        " "
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${modalSignup.__hash}` + " " + "signup-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${modalSignup.__hash}` + " " + "bottom-part",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${modalSignup.__hash}` + " " + "line"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: `jsx-${modalSignup.__hash}` + " " + "bottom-text",
                            children: [
                                " ",
                                translate("pricingPage.signupModalStartFreeTrial"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${modalSignup.__hash}` + " " + "line"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: modalSignup.__hash,
                    children: modalSignup
                })
            ]
        });
    }
}
export default withGenericConfig(PricingModalSignupComponent);
